import React from "react";
import PropTypes from "prop-types";
import { MenuWrapper, MenuItem, DividerList } from "./Menu.styles";
import { useSelector } from "react-redux";
import { getButtonCustom } from "../../Redux/Selectors/appConfigSelector";
import { Button, ButtonLink } from "./MenuItem.styles";

const Menu = ({ isMobile, items, onClose, ...restProps }) => {
  const { buttonText, linkButton, enabled } = useSelector((state) =>
    getButtonCustom(state)
  );
  return (
    <MenuWrapper {...restProps} isMobile={isMobile}>
      {isMobile && enabled && (
        <>
          <ButtonLink href={linkButton} target="_blank" rel="noreferrer">
            <Button type="text" shape="default">
              {buttonText}
            </Button>
          </ButtonLink>
          <DividerList />
        </>
      )}
      {items?.map((item, index) => (
        <>
          <MenuItem key={index} {...item} />
          {isMobile ? <DividerList /> : null}
        </>
      ))}
    </MenuWrapper>
  );
};

Menu.defaultProps = {
  isMobile: false,
  items: [],
};

Menu.propTypes = {
  isMobile: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({ ...MenuItem.propTypes })),
  onClose: PropTypes.func,
};

export default Menu;
